
export function createHeaders(keys, names, width) {
    var result = [];
    for (var i = 0; i < keys.length; i += 1) {
        result.push({
            id: keys[i],
            name: keys[i],
            prompt: names[i],
            width: width[i],
            align: "left",
            padding: 0
        });
    }
    return result;
}